import {
  REQUEST_ALERTS,
  RECEIVE_ALERTS,
  BULK_READ_ALERTS
} from "Constants/redux";

const INITIAL_STATE = {
  isFetching: false,
  shouldRefresh: true,
  alerts: [],
  alertIds: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REQUEST_ALERTS:
      return { ...state, isFetching: true };
    case BULK_READ_ALERTS:
      return { ...state, isFetching: true, alertIds: action.alertIds };
    case RECEIVE_ALERTS:
      const alerts = action.payload;
      return { ...state, isFetching: false, alerts: alerts };
    default:
      return state;
  }
};
